import { motion } from "framer-motion";
import Button from "@/components/site/Button";

export default function NotFound() {
    return (
        <section
            data-testid="page-404"
            className="mx-auto max-w-[1440px] px-5 md:px-10 pt-32 md:pt-48 pb-32 min-h-[70vh] flex flex-col"
        >
            <motion.p
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                className="text-[11.5px] tracking-[0.28em] uppercase text-[var(--hds-clay)] mb-6"
            >
                Pagina niet gevonden
            </motion.p>

            <div className="overflow-hidden">
                <motion.h1
                    initial={{ y: "110%" }}
                    animate={{ y: "0%" }}
                    transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
                    className="font-[Fraunces] text-[26vw] md:text-[20vw] lg:text-[280px] leading-[0.85] tracking-[-0.04em] text-[var(--hds-ink)]"
                    style={{ fontWeight: 300 }}
                >
                    4<em className="italic text-[var(--hds-clay)]">0</em>4
                </motion.h1>
            </div>

            <motion.p
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                    duration: 0.9,
                    ease: [0.16, 1, 0.3, 1],
                    delay: 0.4,
                }}
                className="mt-10 max-w-[46ch] text-[17px] leading-[1.6] text-[var(--hds-ink)]/78"
            >
                Deze pagina lijkt niet te bestaan, of hij heeft besloten
                even te verdwijnen. Adem in, adem uit, en kies een van deze
                sporen.
            </motion.p>

            <motion.div
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9, delay: 0.55 }}
                className="mt-10 flex flex-col sm:flex-row gap-4"
            >
                <Button
                    to="/"
                    data-testid="notfound-cta-home"
                    variant="primary"
                >
                    Terug naar Home
                </Button>
                <Button
                    to="/contact"
                    data-testid="notfound-cta-contact"
                    variant="secondary"
                >
                    Neem contact op
                </Button>
            </motion.div>
        </section>
    );
}
